import { environment } from 'environments';

class DocumentsTabController {
  constructor($scope, Orders) {
    'ngInject';

    Object.assign(this, {
      Orders,
    });

    $scope.$on('tab:selected:documents', () => this.init());
    $scope.$on('visit:loaded', () => this.init());
    this.activeTab = 0;
    this.patient = this.Orders.current.user;
  }

  $onInit() {
    this.init();
  }

  init() {}
}

DocumentsTabController.$inject = ['$scope', 'Orders'];
angular.module('pims').component('visitDocuments', {
  templateUrl: 'app/views/visits/detail/sections/documents/documents.component.html',
  controller: DocumentsTabController,
  controllerAs: 'vm',
  bindings: {
    visit: '=',
  },
});
